import * as React from 'react';
import {formatUtils} from '../../wizard/utils/formatUtils';
import * as ValidateConstant from '../../wizard/constants/ValidateConstant';
import AssetsManager from '../utils/AssetsManager';
import {GLOBAL} from '../../wizard/constants/LabelConstants';
import {KEYS} from '../../wizard/constants/KeysConstants';
import {SelectSearchProps, SelectSearchState} from '../types/components';
import * as InputTextTypes from './InputTextTypes';
import {Catalog} from '../types/common';
import { getSafe } from '../utils/GeneralUtils';
import WarningIcon from './WarningIcon';
import {keepOnlyNumberCharacters} from '../utils/NumberUtils';

class SelectSearchComponent extends React.Component<SelectSearchProps, SelectSearchState> {

    constructor(props) {
        super(props);
        // @ts-ignore
        this.state = {
            showSelector: false,
            filterItems: this.props.filter ? [] : this.props.data,
            inputText: '',
            isLoading: false,
        };
    }

    static defaultProps = {
        default_value: '',
        customClass: '',
        bottom: false,
        insertInput: false,
        filter: true,
        disabled: false,
        showIconWarning: true,
        showMissingCatalog : false
    };

    public refs: {
        itemInput: HTMLInputElement;
        resultList: HTMLInputElement;
    };

    selectedValue = (value): Catalog => {
        if (!this.props.insertInput) {
            let elements: Catalog[];
            if (this.props.onInputChange) elements = this.state.filterItems;
            else elements = this.props.data;
            return elements.find(key => value.id === key.id);
        }
        return value;
    }

    handleOnChange = (value: Catalog, existInList: boolean = true): void => {
        const selected: Catalog = this.selectedValue(value);
        const error: string = this.validateEmpty(value);
        if (existInList) this.closeWindow();
        this.props.onChange(selected, error);
    }

    validateEmpty = value => this.props.required && !value ? ValidateConstant.ERROR_REQUIRED : null;

    inputChange = (e: any) => {
        const {data, inputType} = this.props;
        let value: string = formatUtils.fixText(e.currentTarget.value);
        if (inputType === InputTextTypes.NUMBER) {
            value = keepOnlyNumberCharacters(value)
        }
        let newList: Catalog[] = [];
        if (this.props.onInputChange) {
            this.props.onInputChange(value, this.updateData);
        } else {
            newList =
                !!data ? [...data.filter(itemRemove => formatUtils.fixText(itemRemove.value)
                .includes(value))] : [];
        }
        this.setState({
            filterItems: newList,
            inputText: value,
            isLoading: !!this.props.onInputChange
        });
    }

    inputFocusAction = (e) => {
        e.stopPropagation();
        document.removeEventListener('click', this.clickOut);
        this.refs.itemInput.focus();
    }

    inputBlurAction = (e) => {
        e.stopPropagation();
        document.addEventListener('click', this.clickOut);
    }

    updateData = (data: Catalog[]) => {
        this.setState({
            ...this.state,
            filterItems: data,
            isLoading: false,
        });
    }

    down = (e) => {
        const resultList: any = this.refs.resultList;
        if (e.keyCode === KEYS.KEY_CODE_DOWN_ARROW) {
            e.preventDefault();
            resultList.getElementsByTagName('li')[0].getElementsByTagName('a')[0].focus();
        }

        if (this.props.insertInput && (e.keyCode === KEYS.KEY_CODE_ENTER || e.keyCode === KEYS.KEY_CODE_TAB)) {
            e.preventDefault();
            const value = e.target.value;
            const totalResultList = resultList.getElementsByTagName('li');
            if (totalResultList.length === 1) {
                resultList.getElementsByTagName('li')[0].getElementsByTagName('a')[0].click();
            } else {
                this.handleOnChange({value, id: value, payload: ''}, false);
            }
        }

        if (!this.props.insertInput && (e.keyCode === KEYS.KEY_CODE_ENTER || e.keyCode === KEYS.KEY_CODE_TAB)) {
            e.preventDefault();
            const totalResultList = resultList.getElementsByTagName('li');
            totalResultList.length === 1 && resultList.getElementsByTagName('li')[0]
                .getElementsByTagName('a')[0].click();
        }
    }

    onNavList = (e) => {
        const activeElement: any = document.activeElement;
        const resultList: any = this.refs.resultList;
        const listLength: number = resultList.getElementsByTagName('li').length;
        const current: any = activeElement.dataset.order;
        const input: any = this.refs.itemInput;

        if (e.keyCode === KEYS.KEY_CODE_DOWN_ARROW) {
            e.preventDefault();
            if (current < (listLength - 1)) {
                resultList.getElementsByTagName('li')[parseInt(current, 0) + 1]
                    .getElementsByTagName('a')[0].focus();
            } else {
                input.focus();
            }
        } else if (e.keyCode === KEYS.KEY_CODE_UP_ARROW) {
            e.preventDefault();
            if (current > 0) {
                resultList.getElementsByTagName('li')[parseInt(current, 0) - 1]
                    .getElementsByTagName('a')[0].focus();
            } else {
                input.focus();
            }
        } else {
            if (e.keyCode !== KEYS.KEY_CODE_ENTER) {
                input.focus();
            }
        }
    }

    closeWindow = () => {
        this.setState({
            inputText: '',
            showSelector: false
        });
    }

    toggleDw = () => {
        if (!this.state.showSelector) {
            this.setState({
                showSelector: true
            });
            if (this.props.filter) {
                const input: any = this.refs.itemInput;
                setTimeout(
                    () => {
                        this.refs.itemInput.focus();
                    },
                    100
                );
            }
        } else {
            this.closeWindow();
        }
    }

    onFocusButton = (event: any) => {
        if (event.keyCode === KEYS.KEY_CODE_DOWN_ARROW) {
            const input: any = this.refs.itemInput;
            setTimeout(
                () => {
                    this.refs.itemInput.focus();
                },
                100
            );
            this.toggleDw();
        }
    }

    clickOut = (event: any) => {
        if (event.target.classList && this.state.showSelector) {
            let includeClass = false;
            const itemList = Object.keys(event.target.classList).map((item) => {
                if (event.target.classList[item] === this.props.id) {
                    includeClass = true;
                }
            });
            if (!includeClass) {
                this.closeWindow();
            }
        }
    }

    componentDidMount() {
        document.addEventListener('click', this.clickOut);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.clickOut);
    }

    isValidValue = () => {
        const {data, value} = this.props;
        let isValid = false;
        if (data && data.length > 0 && value && value.id) {
            data.map((item) => {
                if (item.id && item.id.toLowerCase() === value.id.toLowerCase()) {
                    isValid = true;
                }
            });
        }
        return isValid;
    }

    render() {
        const {
            id,
            label,
            placeholder,
            required,
            customClass,
            data,
            value,
            hasError,
            labelError,
            insertInput,
            inputType,
            disabled,
            showIconWarning,
            showMissingCatalog,
            helpAction
        }: SelectSearchProps = this.props;

        const invalidClass = hasError && labelError && 'is-invalid';

        const inputTypeToSet = inputType === InputTextTypes.PASSWORD ? 'password' : 'text';
        const inputModeToSet= inputType === InputTextTypes.NUMBER ? 'numeric' : 'text';

        return (
            <div className={`custom-select-search ${customClass} ${id} form-group custom-input input-label`}>

                {label && <label htmlFor={id}>{label}&nbsp;{label && required && <span className="asterisk">*</span>}
                    {helpAction !== null && helpAction !== undefined &&
                        <img onClick={helpAction} className={`ic ${hasError && labelError ? 'help' : ''} cursor-pointer`} alt="" height="12"
                             src={AssetsManager('/assets/images/common/questionIcon.png')}/>}
                    {hasError && labelError && showIconWarning && <span className="ic"><WarningIcon/></span>}
                </label>}

                <a href="#" onKeyDown={this.onFocusButton} onClick={(e) => {
                    e.preventDefault();
                    this.toggleDw();
                }}
                   className={
                       `truncate activate-button ${invalidClass} ${
                           (data && data.length < 1) || disabled ? 'disable text-secondary-lighten-2' : ''} ${id}`
                   }>
                    {showMissingCatalog && value && value.value ? value.value :
                        this.isValidValue() && value && value.value ? value.value : placeholder}
                    {!disabled && <span className={`arrow ${id}`}>
                        <img className={id}
                             alt="arrow" src={AssetsManager('/assets/images/common/arrow-dropdown.svg')}/>
                    </span>}
                </a>
                <div id={`dropdown_${id}`}
                     className={`${id}
                     ${this.props.filter ? '' : 'no-filter'}
                     dropdown-content ${(!this.state.showSelector || disabled) ? 'hide' : ''}
                     ${!label ? 'without-label' : ''}`}>

                    <div className="close-responsive-data text-center" onClick={this.closeWindow}>
                        <label htmlFor={id} className="">
                            {label}{required && <span className="asterisk">*</span>}
                        </label>
                        <img src={AssetsManager('/assets/images/common/modal-close-icon.svg')} alt="close"
                             className="close-button mt-1"/>
                    </div>
                    {this.props.filter ?
                        <div className={`search-input ${id}`}>
                            <input onFocus={this.inputChange}
                                   onChange={this.inputChange}
                                   onClick={this.inputFocusAction}
                                   onBlur={this.inputBlurAction}
                                   onKeyDown={this.down}
                                   type={inputTypeToSet}
                                   inputMode={inputModeToSet}
                                   disabled={disabled}
                                   ref="itemInput"
                                   value={this.state.inputText}
                                   className="form-control"
                                   placeholder="filtrar resultados" />
                        </div>
                        : null}

                    <div className={`over-item-bg ${id} ${getSafe(() => this.state.filterItems.length) === 0 && 'border-0'}`}>
                        <div className={`container-list-search ${id}`}>
                            <ul ref="resultList" className={`${id} result-list`} onKeyDown={this.onNavList}>
                                {this.state.filterItems.length > 0 ?
                                    this.state.filterItems.map((result, i) => {
                                        return <li key={i}
                                                   data-content={formatUtils.fixText(result.value)}
                                                   className={`${id}`}>
                                            <a href="" data-order={i}
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   this.handleOnChange(result);
                                               }}>
                                                {result.value}
                                            </a>
                                        </li>;
                                    })
                                    :
                                    !insertInput && <ol className={`${id}`}>
                                        <a>{this.state.isLoading ? GLOBAL.LOADING : GLOBAL.NO_RESULTS}</a>
                                    </ol>
                                }
                            </ul>
                        </div>
                    </div>
                </div>

                {hasError && labelError &&
                <strong id={`${name}Help`}
                        className={`form-text ${invalidClass}`}>
                    {labelError}
                </strong>}

            </div>
        );
    }
}

export default SelectSearchComponent;
